// src/components/ContentViews/MapView.js
import React, { useEffect, useRef } from 'react';
import MapShow from './MapShow'; // Import the MapShow component

const MapView = ({ userSelectedCity }) => {
  const containerRef = useRef(null); // Create a ref for the map container
  const mapRef = useRef(null); // Ref to hold the MapKit map instance

  // Define default region (San Francisco)
  const defaultRegion = new window.mapkit.CoordinateRegion(
    new window.mapkit.Coordinate(37.7749, -122.4194), // Default center (San Francisco)
    new window.mapkit.CoordinateSpan(0.1676, 0.354) // Default span
  );

  useEffect(() => {
    // Update map region when userSelectedCity changes
    if (mapRef.current && userSelectedCity && Array.isArray(userSelectedCity.coords)) {
      const [latitude, longitude] = userSelectedCity.coords;
      if (latitude !== undefined && longitude !== undefined) {
        const newRegion = new window.mapkit.CoordinateRegion(
          new window.mapkit.Coordinate(latitude, longitude),
          new window.mapkit.CoordinateSpan(0.05, 0.05)
        );
        mapRef.current.setRegionAnimated(newRegion); // Update the map's region
      }
    }
  }, [userSelectedCity]);

  return (
    <div
      ref={containerRef} // Attach the ref to the div for the map container
      className="relative w-full h-full"
    >
      <div id="mapContainer" className="absolute inset-0" /> {/* Map container for MapKit */}
      <MapShow ref={mapRef} initialRegion={defaultRegion} /> {/* Initialize the map with default region */}
    </div>
  );
};

export default MapView;
